import { ComponentType } from 'react';
import axios from 'axios';
import { generatePath } from 'react-router';

// TYPES
import { UrlParamsToReplace } from '@/types/common.types';

// CONSTANTS
import { appVersion } from '@/constants/common';

// UTILITY
import bugsnag from '@/utility/bugsnagClient';
import { semverGreaterThan } from '@/utility/common';

export const getLink = (route: string, params: UrlParamsToReplace = {}): string => {
  let updatedRoute = route;
  try {
    updatedRoute = generatePath(route, params);
  } catch {
    Object.keys(params).forEach(param => {
      updatedRoute = updatedRoute.replace(`:${param}`, String(params[param]));
    });
  }

  return updatedRoute;
};

export function retry(
  fn: () => Promise<any>,
  retriesLeft = 5,
  interval = 1000,
): Promise<{ default: ComponentType<any> }> {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(async () => {
          if (retriesLeft === 4) {
            try {
              await axios
                .get(`${window.location.origin}/meta.json`)
                .then(response => response.data)
                // eslint-disable-next-line consistent-return
                .then(meta => {
                  const latestVersion = meta.version;
                  const currentVersion = appVersion;

                  const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);

                  if (shouldForceRefresh) {
                    return window.location.reload();
                  }
                });
            } catch (e) {
              bugsnag.notify(new Error(`meta - error--${JSON.stringify(e)}`));
            }
          }

          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}

export const getReferrer = () => {
  return document.referrer ? document.referrer.split('/')[2] : '';
};
